export const ICONS_VERSION = "1695287109166";
export const ICON_SPRITE = "/icons-generated-new/_icon-sprite-new.svg";
